import _regenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import router from './router';
import store from './store';
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getRefreshToken, getToken } from '@/utils/auth';
import { refreshAccessToken } from '@/utils/token-refresh';
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/403', '/404']; // no redirect whitelist
function ensureAccessToken() {
  return _ensureAccessToken.apply(this, arguments);
}
function _ensureAccessToken() {
  _ensureAccessToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
    var token, _yield$refreshAccessT, accessToken, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          token = getToken();
          if (!token) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, token);
        case 1:
          if (getRefreshToken()) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, '');
        case 2:
          _context2.p = 2;
          _context2.n = 3;
          return refreshAccessToken();
        case 3:
          _yield$refreshAccessT = _context2.v;
          accessToken = _yield$refreshAccessT.accessToken;
          return _context2.a(2, accessToken);
        case 4:
          _context2.p = 4;
          _t2 = _context2.v;
          _context2.n = 5;
          return store.dispatch('user/resetToken');
        case 5:
          return _context2.a(2, '');
      }
    }, _callee2, null, [[2, 4]]);
  }));
  return _ensureAccessToken.apply(this, arguments);
}
router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, from, next) {
    var hasToken, hasRoles, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          // start progress bar
          NProgress.start();
          // 添加调试信息

          // 不加settings.title 会出现 undefined
          document.title = getPageTitle(to.meta.title);
          // determine whether the user has logged in
          _context.n = 1;
          return ensureAccessToken();
        case 1:
          hasToken = _context.v;
          if (!hasToken) {
            _context.n = 8;
            break;
          }
          if (!(to.path === '/login')) {
            _context.n = 2;
            break;
          }
          // if is logged in, redirect to the home page
          store.dispatch('app/getGrant');
          next({
            path: '/'
          });
          NProgress.done();
          _context.n = 7;
          break;
        case 2:
          if (!(to.path === '/403')) {
            _context.n = 3;
            break;
          }
          next();
          _context.n = 7;
          break;
        case 3:
          // determine whether the user has obtained his permission roles through getInfo
          store.dispatch('app/getGrant');
          hasRoles = store.getters.roles && store.getters.roles.length > 0;
          if (!hasRoles) {
            _context.n = 4;
            break;
          }
          if (store.getters.roles.includes('ROLE_TEACHER') && store.getters.roles.length === 1) {
            next({
              path: '/403'
            });
            NProgress.done();
          } else {
            next();
          }
          _context.n = 7;
          break;
        case 4:
          _context.p = 4;
          // get user info
          store.dispatch('user/getInfo').then(function () {
            store.dispatch('permission/generateRoutes').then(function (accessRoutes) {
              // 使用addRoute代替已废弃的addRoutes
              accessRoutes.forEach(function (route) {
                router.addRoute(route);
              });
              next(_objectSpread(_objectSpread({}, to), {}, {
                replace: true
              }));
            });
          });
          _context.n = 7;
          break;
        case 5:
          _context.p = 5;
          _t = _context.v;
          _context.n = 6;
          return store.dispatch('user/resetToken');
        case 6:
          Message.error(_t || 'Has Error');
          next("/login?redirect=".concat(to.path));
          NProgress.done();
        case 7:
          _context.n = 9;
          break;
        case 8:
          /* has no token*/

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            NProgress.done();
          }
        case 9:
          return _context.a(2);
      }
    }, _callee, null, [[4, 5]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});